/**
 * @file スプレッドシート用検証関数
 * @namespace ddv2.library
 */
import core from '@/rahmen/core'
import dayjs from 'dayjs'
/**
 * @module validator4sps
 */
export default {
  /**
   * 数値型検証
   * @param {Object} obj 検証対象
   * @param {Object} obj.value 検証対象値
   * @returns COMV0004
   */
  numericalValidate: function (value) {
    if (value === null || value === undefined) { return null }
    const v = '' + value
    if (v === '') { return null }
    return core.isNumeric(v) ? value : null
  },

  /**
   * 数値桁数一致検証
   * @param {Object} obj 検証対象
   * @param {Object} obj.value 検証対象値
   * @param {Number} obj.intDigit 検証対象正数部桁数
   * @param {Number} obj.decimalDigit 検証対象少数部桁数
   */
  fixedNumericalDigitValidate: function (value, intDigit, decimalDigit) {
    console.log('fixedNumericalDigitValidate', value, intDigit, decimalDigit)

    if ([undefined, null].includes(value)) { return null }
    if ([undefined, null].includes(intDigit)) { return null }
    if ([undefined, null].includes(decimalDigit)) { return null }
    if (this.numericalValidate(value) === null) { return null }

    let val = String(value).replace('-', '')
    let isInt = val.indexOf('.') === -1

    const num = isInt ? parseInt(val, 10) : parseFloat(val, 10)
    val = String(num)
    isInt = val.indexOf('.') === -1

    console.log('fixedNumericalDigitValidate', value, val, intDigit, decimalDigit)

    if (isInt && val.length === intDigit) { return null }
    if (!isInt) {
      const intLen = val.split('.')[0].length
      const decLen = val.split('.')[1].length
      if (intLen === intDigit || decLen === decimalDigit) { return null }
    }
    return value
  },

  /**
   * 日付型検証
   * @param {Object} obj 検証対象
   * @param {Object} obj.value 検証対象値
   * @returns 日付文字列
   */
  dateValidate: function (value) {
    if ([undefined, null, ''].includes(value) || !dayjs(value, 'YYYY/MM/DD', true).isValid()) { return null }
    return dayjs(value, 'YYYY/MM/DD', true).format('YYYY/MM/DD')
  },

  /**
   * 時刻検証
   * @param {Object} obj 検証対象
   * @param {Object} obj.value 検証対象値
   * @returns [COMV0014, COMV0013, COMV0018]
   */
  timeValidate: function (value, isStraddle) {
    if (value === null || value === undefined || value === '') { return null }
    const cnt = (value.match(new RegExp(':', 'g')) || []).length
    if (cnt !== 1) { return null }

    const upperHour = isStraddle ? 99 : 23
    const part = value.split(':')
    const h = parseInt(part[0], 10)
    const m = parseInt(part[1], 10)

    if (h >= 0 && h <= upperHour && m >= 0 && m <= 59) {
      const HH = ('00' + h).slice(-2)
      const MM = ('00' + m).slice(-2)
      return HH + ':' + MM
    } else {
      return null
    }
  }
}
